

import '../../../App.css';

import openIcon from "../../pictures/2D_editor_icon_open.png";
import saveIcon from "../../pictures/2D_editor_icon_save.png";
import saveIconOnline from "../../pictures/2D_editor_icon_save_web.png";
import layerIcon from "../../pictures/2D_editor_icon_layers.png";
import backIcon from "../../pictures/2D_editor_icon_undo1.png";
import forwardIcon from "../../pictures/2D_editor_icon_undo2.png";
import { useAppSelector, useAppDispatch } from '../../../store/hooks'
import ToolbarButtonOpen from './toolbarButtonOpen';
import ToolbarButtonSave from './toolbarButtonSave';
import ToolbarButton from '../Toolbar/toolbarButton';
import fitToScreenIcon from "../../pictures/2D_editor_icon_fit.png";
import { fitToScreen } from "../../../store/interface";
import { setSending, toggleLayerModalOpen } from '../../../store/interaction';
import { RootState } from '../../../store/store';
import { ActionCreators } from 'redux-undo';

interface ToolbarProps {
  hideOpenButton?: boolean;
  hideSaveButton?: boolean;
}

const Ribbon = (toolbarProps: ToolbarProps) => {

  const boundingbox = useAppSelector((state: RootState) => state.model.present.boundingbox);
  const dispatch = useAppDispatch();

  return (
    <div>
      <button className='toolbar__button' />
      {!toolbarProps.hideOpenButton && (
        <ToolbarButtonOpen icon={openIcon} tooltip={'open'} toolname={'open'} />
      )}
      {!toolbarProps.hideSaveButton && (
        <ToolbarButtonSave icon={saveIcon} tooltip={'save'} toolname={'save'} />
      )}
      <ToolbarButton
        onClick={() => dispatch(ActionCreators.undo())}
        icon={backIcon}
        tooltip={"back"}
        toolname={"back"}
      />
      <ToolbarButton
        onClick={() => dispatch(ActionCreators.redo())}
        icon={forwardIcon}
        tooltip={"forward"}
        toolname={"forward"}
      />
      <ToolbarButton
        onClick={() => dispatch(fitToScreen(boundingbox))}
        icon={fitToScreenIcon}
        tooltip={"fit to screen"}
        toolname={"fit-to-screen"}
      />
      <ToolbarButton
        onClick={() => dispatch(toggleLayerModalOpen())}
        icon={layerIcon}
        tooltip={'layer'}
        toolname={'layer'}
      />
      {!toolbarProps.hideSaveButton && (
        <ToolbarButton
          icon={saveIconOnline}
          tooltip={'send'}
          toolname={'send'}
          onClick={() => dispatch(setSending(true))}
        />
      )}
    </div >
  );
}


export default Ribbon;
